import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=2a8adf07&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8adf07')) {
      api.createRecord('2a8adf07', component.options)
    } else {
      api.reload('2a8adf07', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=2a8adf07&", function () {
      api.rerender('2a8adf07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/button/Button.vue"
export default component.exports